export const TranslationsCS = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
        hi: 'हिन्दी',
        ko: '한국어',
        ru: 'Русский',
        tr: 'Türkçe',
        nl: 'Nederlands',
        pl: 'Polski',
        ms: 'Bahasa Melayu',
        ro: 'Română',
        cs: 'Čeština',
        hu: 'Magyar',
        ta: 'தமிழ்',
        te: 'తెలుగు',
        bn: 'বাংলা',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
        hi: 'HI',
        ko: 'KO',
        ru: 'RU',
        tr: 'TR',
        nl: 'NL',
        pl: 'PL',
        ms: 'MS',
        ro: 'RO',
        cs: 'CS',
        hu: 'HU',
        ta: 'TA',
        te: 'TE',
        bn: 'BN',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
        hi: 'HIN',
        ko: 'KOR',
        ru: 'RUS',
        tr: 'TUR',
        nl: 'NLD',
        pl: 'POL',
        ms: 'MSA',
        ro: 'RON',
        cs: 'CES',
        hu: 'HUN',
        ta: 'TAM',
        te: 'TEL',
        bn: 'BEN',
    },
    // BASE
    phrases: {
        order_online: 'Objednejte online',
        cart: 'Vozík',
        open_24: '24 hodin',
        closed: 'ZAVŘENO',
        free: 'UVOLNIT',
        something_went_wrong: 'něco se pokazilo',
        try_again: 'zkuste to znovu',
    },
    constants: {
        calendar: {
            days: {
                monday: 'pondělí',
                tuesday: 'úterý',
                wednesday: 'středa',
                thursday: 'čtvrtek',
                friday: 'pátek',
                saturday: 'sobota',
                sunday: 'neděle',
            },
        },
        services: {
            pickup: 'Vyzvednutí',
            delivery: 'Dodání',
            dine_in: 'Jídlo na místě',
            table_booking: 'Rezervace stolu',
        },
        payment: {
            method: {
                cash: 'Hotovost',
                card: 'Karta',
                stripe: 'Credit Card',
                paypal: 'PayPal',
                cardconnect: 'Credit Card',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                razor_pay: 'Razor Pay',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                custom: 'Custom',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                authorized: 'Authorize.net'
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: 'Hotovost',
                card: 'Karta',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                bambora_na: 'Worldline',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                stripe_digital_wallet: 'Google/Apple Pay',
                razor_pay: 'Razor Pay',
                gravity: 'Gravity',
                authorized: 'Authorize.net',
                elavon: 'Elavon',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                custom: 'Custom',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                nuvei: 'Nuvei',
                ONLINE: 'Online',
                online: 'Online'
            },
            status: {
                success: 'Úspěch',
                pending: 'Čeká na vyřízení',
                error: 'Chyba',
                refunded: 'Vráceno',
                refunding: 'Vrácení peněz',
                partial_refunded: 'Částečně vráceno',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'Odstranit',
                drop_here: 'Sem přetáhněte své soubory nebo kliknutím vyberte jeden',
                accepts: 'Přijímá {{fileTypes}} souborů',
                errors: {
                    max_files: 'Povoleno maximálně {{number}}',
                    max_size: 'Maximální velikost souboru {{kilobytes}} kB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'Obchod je momentálně uzavřen a objednávka na místě, která musí být ihned, nemůže být umístěna. Můžete se pokusit objednat na pozdější datum a čas místo toho',
            },
            buttons: {
                order: {
                    book_order: 'Rezervovat stůl / objednat online',
                    order_online: 'Objednejte online',
                    book_table: 'Kniha A Stůl',
                    order: 'Objednávka',
                    book: 'Rezervovat',
                    cart: 'Vozík',
                    restart: 'Restartujte',
                    closed: 'Obchod Uzavřen',
                    not_accepting: 'Nepřijímání objednávek',
                },
            },
        },
        modals: {
            auth: {
                login: 'Přihlášení',
                register: 'Rejstřík',
                register_commence: 'Pokračovat',
                register_complete: 'Vytvořit účet',
                register_confirmation_sent: 'Potvrzovací kód byl odeslán na váš e-mailovou adresu. Vložte jej níže a pokračujte',
                register_confirmation_resent: 'Potvrzovací kód byl znovu odeslán, zkontrolujte svůj spam nebo restartujte proces',
                register_restart: 'Restartujte',
                register_resend_code: 'Znovu odeslat kód',
                register_confirmation_code_subject: 'Potvrzovací kód e-mailu',
                register_confirmation_code_email: 'Váš potvrzovací kód e-mailu je {{confirmation_code}} (vyprší za 24 hodin)',
                login_placeholder: 'E-mailová adresa',
                password_placeholder: 'Heslo',
                confirm_password_placeholder: 'Potvrďte heslo',
                confirmation_code_placeholder: 'Potvrzovací kód e-mailu',
                accept_terms: 'Přijměte Smluvní podmínky',
                accept_terms_view: 'Pohled',
                login_facebook: 'Přihlaste se přes Facebook',
                login_google: 'Přihlaste se pomocí Google',
                benefits: 'Přihlaste se nebo si vytvořte účet pro uložení všech vašich objednávek',
                logged_in: 'Úspěšně přihlášen',
                logged_out: 'Odhlášen',
                password_reset: {
                    init_button: 'Odeslat e-mail pro resetování hesla',
                    init_success: 'Odkaz pro obnovení hesla byl odeslán na váš e-mail',
                    complete_button: 'Obnovit heslo',
                    complete_success: 'Heslo bylo úspěšně resetováno, přihlaste se pomocí nového hesla',
                    forgot_password_text: 'Zapomněli jste heslo?',
                    forgot_password_link: 'Obnovit heslo',
                    remember_password_text: 'Pamatujete si své heslo?',
                    remember_password_link: 'Vraťte se',
                    invalid_title: 'Obnovení hesla je neplatné',
                    invalid_description: 'Tento odkaz pro resetování hesla není platný, vyžádejte si místo něj nové',
                    invalid_link: 'Přejít na přihlášení',
                    title: 'Obnovení hesla',
                    description: 'Zadejte nové heslo ke svému účtu',
                },
                error_generic: 'Něco se pokazilo, zkuste to prosím znovu nebo nás kontaktujte',
                error_accept_terms: 'Přijměte prosím smluvní podmínky',
                error_password_length: 'Minimálně 6 znaků pro heslo',
                error_social: 'Něco se pokazilo, zkuste to znovu nebo nás kontaktujte',
                error_confirmation_code: 'Neplatný potvrzovací kód',
                error_invalid_code: 'Neplatný potvrzovací kód',
                error_exists: 'Uživatel již existuje',
                error_invalid_email_pass: 'Neplatná e-mailová adresa nebo heslo',
                error_password_no_match: 'Hesla se navzájem neshodují',
                error_user_not_found: 'Žádný uživatel s touto e-mailovou adresou',
                error_invalid_email: 'Neplatná e-mailová adresa',
                error_invalid_reset_token: 'Neplatný odkaz na reset, požádejte o jiný',
            },
            booking: {
                form: {
                    name: 'Celé jméno',
                    email: 'E-mailová adresa',
                    phone: 'Telefonní číslo',
                    number_of_people: 'Počet Lidí',
                    number_of_people_max: 'Počet lidí (max. {{max_people}})',
                    number_of_people_min: 'Počet lidí ({{min_people}} min)',
                    number_of_people_max_min: 'Počet lidí (od {{min_people}} do {{max_people}})',
                    notes: 'Poznámky / zvláštní požadavky',
                    submit: 'Odeslat požadavek na rezervaci',
                    email_optional: '(volitelné)',
                    date: 'Datum',
                    duration: 'Doba trvání',
                    seating: 'Dostupné časy',
                    number_of_guests: 'Počet hostů',
                    notes_placeholder: 'Alergie, příležitost, preference místa',
                    reserving: 'Rezervuji...',
                    reserve_table: 'Rezervovat stůl',
                    please_choose_a_date_and_time: 'Vyberte datum a čas.',
                    invalid_people: 'Počet osob musí být mezi {{min}} a {{max}}.',
                    party_size_max_fallback: 'povolené maximum',
                    loading_available_times: 'Načítání dostupných časů…',
                    select_a_date_to_see_available_times: 'Vyberte datum pro zobrazení dostupných časů.',
                    no_times_available_for_this_date: 'Pro toto datum nejsou k dispozici žádné časy. Vyberte jiný den.',
                    shift: 'Směna',
                    service_times: 'Provozní doba',
                    new_shift: 'Nová směna',
                    time: 'čas',
                    times: 'časy',
                    unavailable: 'Nedostupné',
                    available: 'Dostupné',
                    required_name: 'Zadejte své jméno.',
                    required_phone: 'Zadejte své telefonní číslo.',
                    required_email: 'Zadejte svou e-mailovou adresu.',
                    invalid_email: 'Zadejte platnou e-mailovou adresu.',
                    required_terms: 'Před rezervací přijměte podmínky.',
                    reservation_is_unavailable: 'Rezervace není k dispozici.',
                    please_contact_the_restaurant_directly: 'Kontaktujte restauraci přímo.',
                    almost_done: 'Téměř hotovo',
                    your_details: 'Vaše údaje',
                    tell_us_who_s_coming: 'Řekněte nám, kdo přijde, abychom mohli potvrdit vaši rezervaci.',
                    book_your_table: 'Rezervujte si stůl',
                    choose_a_time_that_works_for_you: 'Vyberte čas, který vám vyhovuje.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'Odešlete žádost o rezervaci a restaurace se postará o zbytek.',
                    select_date: 'Vybrat datum',
                    standard: 'Standardní',
                    minutes: 'minut',
                    next: 'Další →',
                    back: '← Zpět',
                    accept_terms: 'Souhlasím s podmínkami.',
                    info_1: 'Jakmile bude vaše rezervace přijata nebo zamítnuta, obdržíte upozornění e-mailem',
                },
                errors: {
                    not_found: "Rezervace neexistuje. Možná byla smazána",
                    generic: 'Něco se pokazilo, obnovte stránku nebo nás kontaktujte',
                    something_went_wrong: 'Něco se pokazilo',
                    accept_terms: 'Přijměte prosím smluvní podmínky',
                    required_phone: 'Zadejte prosím své telefonní číslo',
                    required_email: 'Zadejte prosím svůj email',
                    required_zip: 'Zadejte prosím PSČ pro fakturaci',
                    required_name: 'Zadejte prosím své jméno',
                    invalid_email: 'Zadejte prosím platnou e-mailovou adresu',
                    invalid_phone: 'Zadejte prosím platné telefonní číslo',
                    invalid_people: 'Neplatný počet osob',
                    missing_custom_fields: 'Vyplňte prosím všechna povinná pole.',
                    booking_capacity_threshold: 'Na tento čas jsme plně obsazeni. Zkuste jiný čas.',
                    slot_unavailable: 'Pro tento počet osob jsme plně obsazeni. Zkuste jiný čas.',
                    booking_date_paused: 'Rezervace na toto datum jsou pozastaveny. Vyberte jiný den.',
                    invalid_table_assignment: 'Tyto stoly nepojmou vaši skupinu. Vyberte jiný čas.',
                    exceeded_order_limit: 'Příliš mnoho žádostí o rezervaci. Zkuste to později.',
                    validation_failed_recaptcha_v3: 'Zjištěn neobvyklý provoz. Používáte VPN? Dokončete ověření výše a zkuste to znovu.',
                    validation_failed_recaptcha_v2: 'Rezervaci se nepodařilo zahájit. Zkuste to znovu nebo použijte jiný způsob. Pokud používáte VPN, zkuste ji nejprve vypnout.',
                    booking_already_exists: 'Tato rezervace již byla odeslána. Zkontrolujte e-mail nebo otevřete odkaz na rezervaci.',
                    invalid_party_size: 'Vyberte platný počet osob.',
                    invalid_request: 'Neplatný požadavek. Obnovte stránku a zkuste to znovu.',
                    table_booking_unavailable: 'Rezervace stolu není k dispozici.',
                },
            },
            cart: {
                title: 'Vozík',
                proceed_to_checkout: 'Pokračujte k pokladně',
                edit_dish: 'Upravit',
                remove_dish: 'Odstranit',
                no_items_1: 'Žádné položky v košíku',
                no_items_2: 'Chcete-li pokračovat, přidejte nejprve nějaké',
                free_delivery_notice: 'Doručení zdarma pro objednávky nad {{value, currency}}',
                errors: {
                    min_order_promo: 'Před uplatněním této promoakce je vyžadována minimální hodnota košíku {{value, currency}}',
                    min_order_delivery: 'Minimální hodnota košíku {{value, currency}} pro doručení',
                },
                promo: {
                    heading: 'Propagační kód',
                    placeholder: 'Zadejte svůj propagační kód',
                    add: 'Přidat kód',
                    title: 'Akce {{name}} přidána do košíku',
                    fixed_discount: '{{value, currency}} vypnuto',
                    percent_discount: 'Sleva {{value}}%',
                    added_to_cart: 'Akce přidána do košíku',
                    errors: {
                        not_found: 'Propagace nenalezena',
                        disabled: 'Propagace je zakázána',
                        not_available: 'Promo akce momentálně není k dispozici',
                        not_eligible: 'Nelze uplatnit propagační kód',
                        not_available_time: 'Promo akce tentokrát neplatí',
                        logged_in_only: 'Pro použití této promo akce musíte být přihlášeni',
                        already_used: 'Tuto promo akci jste již využili',
                        invalid: 'Tato akce již není platná',
                        invalid_service: 'Tato akce neplatí pro vámi vybranou službu',
                        later_only: 'Platí pouze pro předobjednávky',
                        now_only: 'Platí pouze pro objednávky s okamžitou platností, nikoli pro předobjednávky',
                        generic: 'Jejda... něco se pokazilo a bylo zaznamenáno',
                        dishes_required_multi: 'Tato promo akce se uplatní pouze v případě, že do košíku přidáte určité položky',
                        dishes_required_single: "Tato promo se uplatní pouze pro '{{dish}}'",
                    },
                },
                tip: {
                    title: 'Tip na objednávku',
                    placeholder: 'Přidejte tip na objednávku',
                },
            },
            free_items_promo: {
                title: 'Položky zdarma',
                usage_confirmation: {
                    question: 'Máte nárok na bezplatné položky. Chcete je vidět a přidat?',
                    cancellation: "Ne, nechci bezplatné položky",
                    acceptance: 'Ano',
                },
                free_items_selection: {
                    multiple: {
                        description: 'Vyberte {{number}} bezplatných položek',
                    },
                    single: {
                        description: 'Vyberte bezplatnou položku',
                    },
                    confirm_button: 'Potvrdit',
                },
            },
            checkout: {
                title: 'Pokladna',
                subtitle: 'Potvrďte podrobnosti objednávky',
                details: {
                    service: 'Servis',
                    due: 'Splatné',
                    due_now_asap: 'Nyní / ASAP',
                    address: 'Doručovací adresa',
                    total: 'Celkový',
                    table: 'Tabulka',
                    store_location: 'Adresa prodejny',
                },
                customer: {
                    title: 'Zákazník',
                    subtitle: 'Pro uložení objednávky a podrobností se přihlaste',
                    button: 'Přihlášení',
                    name: 'Celé jméno',
                    email: 'E-mailová adresa',
                    phone: 'Telefon',
                    phone_important: 'Telefon (důležité)',
                    notes: 'Poznámky k objednávce',
                    delivery_notes: 'Dodací pokyny / poznámky k objednávce',
                    optional: 'volitelný',
                },
                payment: {
                    title: 'Způsob platby',
                    qr_modal_help: 'Použijte svou mobilní aplikaci {{app}} pro skenování QR a dokončení platby pro tuto objednávku. Jakmile je platba dokončena na vaší mobilní aplikaci, můžete tuto QR modal zavřít. Nepleťte se s tím, že jste dokončili proces platby.',
                    switch_to_app_help: 'Kliknutím na níže uvedený tlačítko se automaticky otevře mobilní aplikace {{app}} pro dokončení platby pro tuto objednávku. Jakmile je platba dokončena na vaší mobilní aplikaci, můžete tuto modal zavřít. Nepleťte se s tím, že jste dokončili proces platby.',
                    open_app: 'Otevřete aplikaci {{app}}',
                    continue: 'Pokračovat',
                    continue_to_payment: 'Pokračovat na {{method}}',
                    back_to_cart: 'Zpět do košíku',
                },
                accept_terms: 'Přijměte Smluvní podmínky',
                accept_terms_view: 'Pohled',
                processing_order: 'Zpracování objednávky',
                warning: {
                    different_payment_currency: 'Ceny v obchodě jsou v {{store_currency}}, ale metoda platby je v {{payment_currency}}',
                    closing_soon: 'Brzy se zavře, objednávky je nutné zadat do {{value}} minut',
                    closed: 'Omlouváme se, tato služba byla uzavřena a objednávky nejsou přijímány',
                    paused: 'Omlouváme se, tato služba byla pozastavena a objednávky v tuto chvíli nejsou přijímány',
                    expired: 'Vaši objednávku ve vámi zvoleném čase již nemůžeme splnit. Vyberte prosím pozdější datum nebo čas',
                },
                errors: {
                    walletly_promo: 'Propagační akce Peněženky má chybu, zkuste prosím jinou akci!',
                    stripe_generic: 'Chyba kreditní karty, zkuste to znovu nebo jinou metodou',
                    validation_failed: 'Tuto platbu nelze v tuto chvíli přijmout. Zkuste to znovu později nebo zvolte jiný způsob platby.',
                    validation_failed_recaptcha_v3: 'Byl zjištěn neobvyklý provoz. Používáte VPN? Dokončete prosím výše uvedenou výzvu a zkuste to znovu.',
                    validation_failed_recaptcha_v2: 'Nemohli jsme zahájit platbu. Zkuste to znovu nebo použijte jinou metodu. Pokud používáte VPN, zkuste ji nejprve vypnout.',
                    stripe_loading_fail: 'Při načítání platebního formuláře došlo k chybě, zkuste to prosím znovu',
                    something_went_wrong: 'Něco se pokazilo',
                    paypal_generic: 'S PayPalem se něco pokazilo, zkuste to znovu nebo vyberte jinou platební metodu',
                    payment_fail: 'Platba se nezdařila, zkuste to prosím znovu nebo vyberte jiný způsob platby',
                    payment_cancelled: 'Platba zrušena, zkuste to prosím znovu nebo vyberte jinou platební metodu',
                    payment_error: 'Při zpracování online platby došlo k chybě, zkuste to znovu nebo vyberte jinou platební metodu',
                    payment_declined: 'Vaše platební metoda byla zamítnuta',
                    card_declined: "Vaše karta byla zamítnuta a platba nemohla být zpracována",
                    promo_max_uses_exceeded: "Tento promo kód dosáhl limitu použití a již není dostupný.",
                    store_closed: 'Prodejna je uzavřena a již nepřijímá objednávky',
                    accept_terms: 'Přijměte prosím smluvní podmínky',
                    required_payment: 'Vyberte prosím způsob platby',
                    required_phone: 'Zadejte prosím své telefonní číslo',
                    required_email: 'Zadejte prosím svůj email',
                    required_zip: 'Zadejte prosím PSČ pro fakturaci',
                    required_name: 'Zadejte prosím své jméno',
                    invalid_email: 'Zadejte prosím platnou e-mailovou adresu',
                    invalid_phone: 'Zadejte prosím platné telefonní číslo',
                    invalid_cc_number: 'Číslo vaší kreditní karty je neplatné',
                    invalid_order_amount: 'Minimální částka požadovaná pro tento způsob platby',
                    retry_cc_number: 'Něco se pokazilo, zadejte znovu číslo své kreditní karty a zkuste to znovu',
                    closed: 'Prodejna je uzavřena a nepřijímá objednávky',
                    promo_login_required: 'Pro použití této promo akce musíte být přihlášeni',
                    promo_used: 'Tuto promo akci jste již využili',
                    promo_by_payment_method_not_applicable: 'Akce se nevztahuje na vybranou platební metodu.',
                    missing_custom_checkout_fields: 'Vyplňte prosím všechna povinná pole.',
                    delivery_unavailable: 'Služba doručení nemusí být v tuto chvíli k dispozici. Zvažte prosím objednání Pick Up místo toho',
                    required_delivery_provider: 'Vyberte prosím doručení služby.',
                    required_delivery_quotation: 'Platnost odhadu doručení vypršela.',
                    exceeded_order_limit: 'Momentálně dostáváme hodně zakázek. Vyberte prosím pozdější čas.',
                    exceeded_order_limit_later: 'Vaši objednávku ve vámi zvoleném čase již nemůžeme splnit. Vyberte prosím pozdější datum nebo čas',
                },
                button: {
                    continue: 'Pokračovat k platbě',
                    place_order: 'Zadat objednávku',
                    update_order: 'Aktualizovat objednávku',
                },
                delivery_estimation: {
                    title: 'Odhad doručení',
                    details: {
                        provider: 'Poskytovatel doručení',
                        estimated_fee: 'Odhadovaný poplatek',
                        estimated_total_fee: 'Poplatek za doručení celkem',
                        estimated_discount_fee: 'Sleva z poplatku za doručení',
                        previous_estimated_fee: 'Předchozí odhadovaný poplatek',
                        tips: 'Tipy',
                        estimated_delivery_time: 'Předpokládaná doba dodání',
                        uber_new_estimation: 'Vyžádejte si nový odhad',
                        uber_new_estimation_success: 'Byl použit nový odhad doručení Uber.',
                        uber_estimation_expired: 'Platnost odhadu doručení vypršela',
                        uber_price: 'Držíme cenu Uberu',
                        uber_need_time: 'Potřebuji více času',
                        lalamove_price: 'Držíme poplatek za doručení Lalamove',
                        lalamove_new_estimation_success: 'Byl použit nový odhad doručení Lalalmove.',
                        lalamove_estimation_expired: 'Platnost odhadu doručení vypršela',
                        lalamove_need_time: 'Potřebuji více času',
                        lalamove_new_estimation: 'Vyžádejte si nový odhad',
                    },
                    quotation_error: 'Při výpočtu odhadu doručení se něco pokazilo.',
                },
            },
            customer: {
                age_v: {
                    title: 'Ověření věku',
                    required_for_items: 'Nutné pro objednání určitých položek',
                    min_age: 'Minimální věk: {{age}} let',
                    est_time: 'Odhadovaná doba ověření: {{time}} hodin',
                    upload_description: 'Nahrajte své ID níže pro ověření. Po ověření vás budeme informovat e-mailem. Nahrajte až 2 obrázky s maximální velikostí 2 MB každý',
                    pending_description_1: 'Děkujeme za odeslání vašich dokumentů. Po schválení vás budeme informovat e-mailem',
                    pending_description_2: 'Obnovte stránku pro aktualizaci vašeho stavu ověření. Odhadovaná doba ověření je {{time}} hodin',
                    approved_description: 'Váš účet byl ověřen a můžete objednávat z omezených nabídek',
                    rejected_description: 'Vaše ID bylo odmítnuto. Pokud to chcete zkusit znovu, znovu nahrajte své ID',
                    upload: 'Nahrát',
                    reupload: 'Znovu nahrajte dokumenty',
                    go_back: 'Vraťte se zpět',
                    view_document: 'Zobrazit dokument {{number}}',
                    status: {
                        unverified: 'Neověřeno',
                        pending: 'Čekání na schválení',
                        approved: 'Úspěšně ověřeno',
                        rejected: 'Odmítnuto',
                    },
                },
                headings: {
                    sessions: 'Relace',
                    orders: 'Objednávka',
                    spend: 'Strávit',
                    order_history: 'Historie objednávek',
                    loyalty: 'Věrnost',
                    loyalty_points: 'Věrnostní body',
                    added: 'Promo přidáno.',
                },
                loyalty_errors: {
                    invalid_cart_items: 'Před uplatněním vyberte libovolnou položku!',
                    not_found: 'Promo akce nenalezena!',
                    already_exists: 'Promo akce již existuje!',
                    try_again: 'Tuto dohodu nelze použít. Zkuste to prosím znovu!',
                },
            },
            custom_payment: {
                title: '{{name}} Platební formulář',
                description: 'Vám dosáhli naše online platební formulář. Vložte prosím níže uvedená pole a dokončete platbu. Pokud částka není zadána, vaše údaje budou uloženy, ale nebudou vám účtovány.',
                disabled: 'Tato online platební stránka není správně nakonfigurována. Obraťte se na vlastníka stránky, aby byl problém opraven.',
                success: 'Vaše platba byla úspěšně zpracována a vaše údaje byly uloženy. Děkuju',
                back: 'Zpět na domov',
                fields: {
                    name: 'Celé jméno',
                    email: 'E-mailová adresa',
                    reference: 'Platba Ref.',
                    amount: 'Částka ($)',
                    name_on_card: 'Jméno Na Kartě',
                    submit: 'Odeslat platbu',
                },
                warning: {
                    currency: 'Poznámka: Částka platby v {{actual}}, nikoli {{default}}',
                },
                errors: {
                    generic: 'Něco se pokazilo, zkuste to znovu nebo nás kontaktujte',
                    stripe_generic: 'Chyba kreditní karty, obnovte stránku a zkuste to znovu',
                    payment_fail: 'Platba se nezdařila, zkuste to prosím znovu nebo vyberte jiný způsob platby',
                    payment_cancelled: 'Platba zrušena, zkuste to prosím znovu nebo vyberte jinou platební metodu',
                    payment_error: 'Při zpracování online platby došlo k chybě, zkuste to znovu nebo vyberte jinou platební metodu',
                    payment_declined: 'Vaše platební metoda byla zamítnuta',
                    card_declined: "Vaše karta byla zamítnuta a platba nemohla být zpracována",
                    promo_max_uses_exceeded: "Tento promo kód dosáhl limitu použití a již není dostupný.",
                },
            },
            dish: {
                add: 'Přidat do košíku',
                edit: 'Aktualizovat položku',
                notes: 'Speciální instrukce...',
                ingredients: {
                    title: 'Ingredience',
                    uncheck_remove: 'Chcete-li odstranit, zrušte zaškrtnutí',
                },
                ingredients_title: 'Ingredience',
                combo: {
                    choose_dish: 'Vyberte položku',
                },
                option_sets: {
                    conditions: {
                        select_one: 'Vyberte jednu (povinné)',
                        select_one_optional: 'Vyberte jednu (volitelné)',
                        select_between: 'Vyberte mezi {{min}} - {{max}} (povinné)',
                        select_at_least: 'Vyberte alespoň {{qty}} (povinné)',
                        select_up_to: 'Vyberte až {{qty}} (volitelné)',
                        select_multiple_optional: 'Vybrat více (volitelné)',
                        select_multiple: 'Vybrat více (povinné)',
                        free_amount: 'Prvních {{qty}} zdarma / {{selected}} vybraných',
                    },
                    points: {
                        none_consumed: 'Můžete si zdarma vybrat maximálně {{maxFree}} možností',
                        less_than_total_points: 'Můžete si zdarma vybrat více možností',
                        greather_than_total_points: 'Můžete si vybrat více možností za příplatek',
                    },
                },
                error: 'Opravte všechny možnosti označené červeně',
                added_to_cart: 'Položka přidána do košíku',
            },
            map: {
                zone_fee: 'Poplatek za doručení',
                view_in_google: 'Zobrazit v Mapách Google',
            },
            portal_go_back: {
                title: 'Přejít zpět na vyhledávání restaurací?',
                description: 'Veškeré položky ve vašem košíku budou ztraceny',
                cancel: 'Zrušit',
                proceed: 'Vraťte se zpět',
            },
            order: {
                config: {
                    services: {
                        title: 'Vyberte službu',
                        table_booking: 'Kniha Tabulka',
                    },
                    address_custom: {
                        input_placeholder: 'Zadejte svou adresu',
                    },
                    address: {
                        input_placeholder: 'Najděte svou doručovací adresu',
                        extras_placeholder: 'Číslo jednotky, název budovy, dodací pokyny atd...',
                        search_placeholder: 'Vyhledejte svou adresu',
                        search_input_placeholder: 'Zadejte a vyhledejte',
                        no_address_found: 'Nebyly nalezeny žádné adresy. Zkuste napsat více než 5 znaků',
                        not_found: 'Doručovací adresa nebyla nalezena nebo platná, zkuste to znovu',
                        not_delivering: 'Na tuto adresu momentálně nedoručujeme',
                        not_in_range: 'Vaše adresa není v dosahu naší prodejny',
                        not_in_zone: 'Vaše adresa není v aktivní doručovací zóně',
                        no_number: 'Vaše adresa musí mít číslo ulice',
                        location_permission: 'Povolit tomuto webu přístup k vaší aktuální poloze?',
                        location_permission_warning: "Nemůžete přistupovat k vaší aktuální poloze. Povolte službu polohy na svém zařízení a webovém prohlížeči. Zde jsou nějaké reference:",
                        pick_location: 'Vyberte svou polohu',
                        pick_location_help_text: 'Přetažením značky vyberte umístění na mapě.',
                        use_current_location: 'Použít aktuální polohu',
                        locate_on_map: 'Najděte na mapě',
                    },
                    datetime: {
                        title: 'Kdy byste chtěli svou objednávku',
                        due_now: 'Teď',
                        due_later: 'Později',
                        service_not_available: 'Omlouváme se, ale momentálně nepřijímáme objednávky na {{service}}',
                        currently_closed: '{{service}} aktuálně zavřeno, ale můžete si objednat později',
                        due_unavailable: 'Není k dispozici',
                        due_closed: 'ZAVŘENO',
                        select_date: 'Vyberte Datum',
                        select_time: 'Vyberte Čas',
                        select_order_date: 'Vyberte datum objednávky',
                        select_order_time: 'Vyberte čas objednávky',
                        select_order_date_time: 'Vyberte datum/čas objednávky',
                        select_booking_date: 'Vyberte datum rezervace',
                        select_booking_time: 'Vyberte čas rezervace',
                        no_times_available: 'Na výběr nejsou žádné časy',
                        date_today: '(Dnes)',
                        date_closed: '(ZAVŘENO)',
                        date_bookings_paused: '(Rezervace pozastaveny)',
                        time_slot_closed: 'ZAVŘENO',
                    },
                    number_of_people: {
                        placeholder: 'Počet Lidí',
                    },
                    table: {
                        select: 'Vyberte Tabulka',
                        select_popup_title: 'Vyberte svůj stůl',
                        password: 'Heslo tabulky',
                        password_warning: 'Pokračujte zadáním hesla ke stolu',
                    },
                    warning: {
                        closed: 'Omlouváme se, momentálně máme zavřeno / nepřijímáme žádné objednávky',
                        not_available: 'Omlouváme se, momentálně nepřijímáme žádné objednávky',
                    },
                    eta: {
                        delivery: `Odhadovaná doba doručení je přibližně {{minutesToCustomer}} minut`,
                        pickup: `Objednávka bude připravena přibližně za {{minutesToCustomer}} minut`,
                    },
                    start_button: 'Zahájit objednávku',
                },
                history: {
                    invalid: 'Nemáte nárok na opětovné objednání, protože některé položky, které jste objednali, byly změněny nebo již nejsou dostupné',
                },
                reorder: {
                    title: 'Rychlé opětovné objednání',
                    description: 'Snadno si objednejte položky z předchozích objednávek',
                },
            },
            receipt: {
                errors: {
                    not_found: 'Objednávka nebyla nalezena, obnovte stránku a zkuste to znovu',
                    booking_not_found: 'Rezervace neexistuje. Možná byla smazána',
                    generic: 'Něco se pokazilo, obnovte stránku nebo nás kontaktujte',
                },
                connection: {
                    connected: 'Aktualizace v reálném čase',
                    connecting: 'Připojování aktualizací v reálném čase',
                    disconnected: 'Aktualizace v reálném čase odpojeny',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'Varování',
                    title: 'Odhlášení',
                    body: 'Odhlášením odstraníte všechny položky, které byly přidány do vašeho košíku',
                    cancel: 'Zrušit',
                    proceed: 'Pokračovat',
                },
                order_restart: {
                    warning: 'Varování',
                    title: 'Změnit podrobnosti objednávky',
                    body: 'Změnou podrobností objednávky odstraníte položky z košíku, protože některé položky mohou být nedostupné',
                    cancel: 'Zrušit',
                    proceed: 'Pokračovat',
                },
                order_expired: {
                    subtitle: 'Důležité',
                    title: 'Objednávka změněna na splatnou okamžitě',
                    description: 'Čas vybraný pro vaši objednávku je nyní blízko. Proto byla vaše objednávka upravena na okamžité / co nejdříve',
                    button: 'Dobře',
                },
                order_expiring: {
                    subtitle: 'Důležité',
                    title: 'Brzy vyprší termín objednávek',
                    description: 'Vaše objednávka musí být zadána do {{time, timeFromTimestamp}}, jinak již nebude platná',
                    button: 'Dobře',
                },
                location_permission: {
                    cancel: 'Zrušit',
                    proceed: 'Pokračovat',
                },
            },
            card_payment_authentication: {
                title: 'Ověření platby',
                note: 'Ponechte toto okno otevřené, dokud nedokončíte proces ověření z vaší banky.',
            },
            maps: {
                cancel: 'Zrušit',
                use_location: 'Použít umístění',
            },
            app_refresh: {
                refresh: 'Obnovit',
                title: 'Obnovit obchod',
                description: 'Naše prodejna byla aktualizována. Obnovte prosím svůj prohlížeč, abyste získali nejnovější verzi. Po obnovení můžete potřebovat znovu otevřít svůj košík, abyste mohli pokračovat v procesu kontroly.',
            },
        },
        sections: {
            nav_top: {
                guest: 'Host',
                login: 'Přihlášení',
                login_signup: 'Přihlášení / Registrace',
                logout: 'Odhlášení',
            },
            menus: {
                info: {
                    no_menus: 'Momentálně nejsou k dispozici žádné nabídky',
                    restrictions: 'Omezení nabídky',
                    not_available: 'Nabídka není k dispozici',
                    unavailable: {
                        times: "Menu unavailable, your order requirements don't match below",
                        services: "Menu unavailable, your order requirements don't match below",
                        hours: 'Nabídka není k dispozici, vaše objednací doba není v rámci této dostupné doby nabídky',
                        pre_order: "Menu unavailable, your order doesn't match the pre-order requirements",
                        age: 'Nabídka není k dispozici, pro objednání z této nabídky musíte být přihlášeni pomocí účtu s ověřeným věkem',
                    },
                    services: {
                        title: 'Požadavky na objednávku',
                        pickup: 'Snímače',
                        delivery: 'Dodávky',
                        dine_in: 'Jídlo na místě',
                    },
                    times: {
                        now: 'Žádné předobjednávky',
                        later: 'Pouze předobjednávky',
                    },
                    hours: {
                        title: 'Dostupné hodiny',
                    },
                    preorder: {
                        title: 'Požadavky na předobjednávku',
                        days_in_advance: 'Je nutné objednat {{days}} dní předem',
                        cutoff_time: 'Poslední den uzávěrky v {{time, timeFromTime}}',
                    },
                    age_restricted: {
                        title: 'Věkově omezeno',
                        approved: 'Váš účet je ověřen a můžete objednávat z této nabídky',
                        rejected: 'Pro objednání je vyžadováno ověření věku. Vytvořte si účet a nahrajte své ID',
                    },
                },
                search: {
                    title: 'Prozkoumat položky nabídky',
                    no_result: 'Nic se nevrátilo. Zkusit jiný hledaný výraz?',
                    placeholder: 'Co hledáte?',
                },
            },
            category: {
                restrictions: 'Omezení kategorií',
                not_available: 'Kategorie není k dispozici',
                unavailable: {
                    services: "Kategorie není k dispozici, vaše požadavky na objednávku neodpovídají níže",
                    hours: "Kategorie není k dispozici, vaše objednací doba není v rámci této dostupné doby kategorie",
                },
            },
            info: {
                location: {
                    title: 'Umístění',
                    view_map: 'Zobrazit mapu',
                    phone: 'Telefon',
                },
                hours: {
                    title: 'Otevírací doba',
                    title_special: 'Speciální otevírací doba',
                },
                services: {
                    title: 'Služby',
                    notes: 'Poznámky',
                    delivery: {
                        ranges: 'Rozsah dodávky',
                        zones: 'Dodací zóny',
                        view_zones: 'Zobrazit zóny na mapě',
                        fee: 'Poplatek za doručení',
                        fee_short: 'Poplatek',
                        fee_varies: 'Různé, zobrazeno v košíku',
                        min_order: 'Minimální objednávka',
                        min_order_short: 'Min. obj.',
                        no_min_order: 'Žádná minimální objednávka',
                        free_amount: 'Částka doručení zdarma',
                    },
                },
            },
            contact: {
                title: 'Kontaktujte nás',
                name: 'Jméno',
                email: 'E-mailová adresa',
                phone: 'Telefonní číslo',
                message: 'Zadejte svou zprávu...',
                send: 'Odeslat zprávu',
                success: 'Vaše zpráva byla úspěšně odeslána',
                error: 'Něco se pokazilo, zkuste to znovu nebo později',
            },
            footer: {
                powered_by: 'Vytvořeno pomocí',
                terms_and_conditions: 'Smluvní podmínky',
                privacy: 'Zásady ochrany osobních údajů',
                cookie: 'Zásady používání souborů cookie',
            },
        },
        pages: {
            payment_completed: {
                title: 'Vaše platba byla zpracována. Děkujeme za vaši objednávku!',
                subtitle: 'Informace o objednávce byly odeslány na vaši e-mailovou adresu.',
                back_to_menu: 'Zpět do Menu',
                close_tab: 'Zavřete tuto kartu',
            },
            payment_failed: {
                title: 'Bohužel při zpracování vaší platby došlo k chybě.',
                subtitle: '',
                back_to_menu: 'Zpět do Menu',
                close_tab: 'Zavřete tuto kartu',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Potvrzení o rezervaci',
            details: {
                datetime: 'Rezervace pro',
                number_of_people: 'Ne. Lidí',
                placed: 'Umístěno',
                updated: 'Poslední aktualizace',
                notes: 'Poznámky',
                name: 'Jméno',
                email: 'E-mailová adresa',
                phone: 'Telefon',
                store_address: 'Adresa prodejny',
            },
            status_update: {
                title: 'Rezervace {{number}} aktualizována',
                body: 'Stav vaší rezervace byl aktualizován na {{status}}',
            },
            email_common: {
                name: 'Jméno: {{name}}',
                phone: 'Telefon: {{number}}',
                number_of_people: 'Počet osob: {{number}}',
                date: 'Datum: {{date}}',
                time: 'Čas: {{time}}',
                location: 'Umístění obchodu: {{name}}',
                notes: 'Poznámky: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: 'Rezervace nového stolu {{number}} od {{name}}',
                powered_by: 'Používá technologii {{name}}',
                overview: 'Nový požadavek na rezervaci stolu',
                title: 'Nová rezervace pro {{name}}',
                subtitle: 'Číslo rezervace {{number}}',
                description_confirmed: 'Rezervace byla automaticky potvrzena. Můžete ji zrušit prostřednictvím administrativního panelu a vaši zákazníka budeme informovat e-mailem',
                description_unconfirmed: 'Prosím potvrďte nebo zrušte rezervaci prostřednictvím administračního panelu',
                url_pre_text: 'Zobrazit a aktualizovat na',
            },
            email_new_booking_customer: {
                subject: 'Žádost o rezervaci stolu',
                powered_by: 'Používá technologii {{name}}',
                overview: 'Nový požadavek na rezervaci stolu',
                title: 'Děkujeme za Vaši rezervaci',
                subtitle: 'Číslo rezervace {{number}}',
                description: '<b>Po schválení nebo odmítnutí vás budeme informovat e-mailem.</b><br>Obraťte se na nás, pokud chcete provést jakékoli změny v rezervaci. Podrobnosti vaší rezervace jsou následující:',
                url_pre_text: 'Potvrzení rezervace v reálném čase si můžete prohlédnout na adrese',
            },
            email_update_booking_customer: {
                subject_confirmed: 'Rezervace stolu potvrzena',
                subject_unconfirmed: 'Rezervace stolu zrušena',
                powered_by: 'Používá technologii {{name}}',
                overview: 'Žádost o rezervaci stolu',
                title_confirmed: 'Rezervace potvrzena',
                title_unconfirmed: 'Rezervace zrušena',
                subtitle: 'Číslo rezervace {{number}}',
                description_confirmed: 'Rádi se s vámi setkáme. Obraťte se na nás, pokud chcete provést jakékoli změny v rezervaci',
                description_unconfirmed: 'Omlouváme se, že vaše žádost o rezervaci nemohla být přijata. Omlouváme se za jakékoli potíže, které byly způsobeny. Obraťte se na nás, pokud máte jakékoli dotazy',
                url_pre_text: 'Potvrzení rezervace v reálném čase si můžete prohlédnout na adrese',
            },
            email_status_update_customer: {
                subject: 'Rezervace #{{number}} – {{subjectLabel}}',
                body: 'Vaše rezervace #{{number}} v {{store}} je nyní {{status}}.',
            },
            errors: {},
            status_warning: 'Aktualizujte stav této rezervace na svém administračním panelu na stránce rezervací',
        },
    },
    email_delayed_order: {
        subject: 'Objednávka #{{number}} – {{subjectLabel}}',
        header: 'Aktualizovaný čas přípravy',
        title: 'Aktualizovaný čas přípravy',
        order_number: 'Číslo objednávky: {{number}}',
        description: 'Vaše objednávka bude nyní hotová v {{time}}.',
        order_time_updated_to: 'Čas vaší objednávky byl aktualizován.',
        powered_by: 'Používá technologii {{name}}',
        button_text: 'Sledovat objednávku',
        subject_label: 'Aktualizovaný čas přípravy',
        subject_label_delivery: 'Aktualizovaný čas doručení',
        body_ready: 'Vaše objednávka bude nyní hotová v {{time}}.',
        body_delivery: 'Vaše objednávka bude nyní doručena v {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'Odh. Čas připravenosti',
            est_driver_pickup_time: 'Odh. Doba vyzvednutí řidiče',
            est_delivery_time: 'Odh. Dodací lhůta',
            tab_details: 'Podrobnosti',
            tab_dishes: 'Položky',
            future_order: 'Budoucí řád',
            reprint: 'DOTISK',
            details: {
                order_no: 'Objednávka č.',
                status: 'Postavení',
                placed: 'Umístěno',
                due: 'Splatné',
                due_asap: 'Nyní / ASAP',
                last_updated: 'Poslední aktualizace',
                total: 'Celkový',
                type: 'Typ',
                origin: 'Původ',
                table: 'Tabulka',
                number_of_people: 'Počet Lidí',
                payment_method: 'Způsob platby',
                payment_status: 'Stav platby',
                payment_currency: 'Platební měna',
                notes: 'Poznámky',
                name: 'Jméno',
                email: 'E-mailová adresa',
                phone: 'Telefon',
                distance: 'Vzdálenost',
                driving_time: 'Doba jízdy',
                delivery_zone: 'Zóna',
                delivery_address: 'Doručovací adresa',
                delivery_provider: 'Poskytovatel doručení',
                delivery_tracking: 'Sledování doručení',
                delivery_return_tracking: 'Sledovat návrat',
                delivery_tracking_link: 'Sledovat objednávku',
                tookan_status: 'Stav Tookan',
                tookan_status_failed_book: 'Doručení rezervace se nezdařilo',
                tookan_status_failed_update: 'Aktualizace rezervace se nezdařila',
                tookan_status_success: 'Zarezervováno k doručení',
                store_address: 'Adresa prodejny',
                destination: 'Cíl',
                estimated_arrival_time: 'Odhadovaný čas příjezdu',
                delivery_status: 'Postavení',
                delivery_track_your_order: 'Sledujte svou objednávku',
                delivery_text: 'Dodání',
                arrival_date: 'Datum příjezdu',
            },
            dishes: {
                headings: {
                    quantity: 'množství',
                    item: 'Položka',
                    price: 'Cena',
                },
                notes: 'Poznámky',
                remove_ingredients: 'Odstraňte přísady',
            },
            status_update: {
                title: 'Objednávka {{number}} aktualizována',
                body: 'Stav vaší objednávky byl aktualizován na {{status}}',
            },
            wait_time_update: {
                title: 'Objednávka {{number}} aktualizována',
                body: 'Termín dokončení vaší objednávky byl aktualizován',
            },
            delivery_update: {
                title: 'Objednávka {{number}} aktualizována',
                body: 'Vaše objednávka byla zarezervována k doručení. Viz odkaz na sledování v reálném čase',
            },
            payment_status_update: {
                title: 'Objednávka {{number}} aktualizována',
                body: 'Stav platby vaší objednávky byl aktualizován.',
            },
            email_new_order_restaurant: {
                subject: 'Nová objednávka ({{number}}) – {{name}}',
                powered_by: 'Používá technologii {{name}}',
                overview: 'Oznámení o nové objednávce',
                title: 'Nová objednávka zadána na {{name}}',
                subtitle: 'Číslo objednávky {{number}}',
                description: 'Zobrazte podrobnosti a aktualizace prostřednictvím řídicího panelu správce',
                button_text: 'Sledovat objednávku',
                track_delivery_button_text: 'Sledovat doručení',
            },
            email_new_order_customer: {
                subject: 'Potvrzení objednávky ({{number}})',
                powered_by: 'Používá technologii {{name}}',
                overview: 'Oznámení o nové objednávce',
                title: 'Nová objednávka zadána na {{name}}',
                subtitle: 'Číslo objednávky {{number}}',
                description: 'Prohlédněte si podrobnosti a aktualizace prostřednictvím online účtenky v reálném čase',
                button_text: 'Sledovat objednávku',
                track_delivery_button_text: 'Sledovat doručení',
            },
            email_order_completed_by_customer: {
                subject: 'Objednávka ({{number}}) dokončena zákazníkem',
                powered_by: 'Používá technologii {{name}}',
                overview: 'Oznámení o dokončení objednávky',
                title: 'Objednávka dokončena v {{name}}',
                subtitle: 'Číslo objednávky {{number}}',
                description: 'Zobrazte podrobnosti a aktualizujte svou objednávku prostřednictvím řídicího panelu nebo pomocí potvrzení na adrese',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}}%)',
            tax_in_prices: '{{name}} ({{percent}}%) vč. v ceně',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}}%)',
            fee_fixed: '{{name}}',
            delivery_fee: 'Poplatek za doručení',
            delivery_fee_offset: 'Sleva z poplatku za doručení',
            delivery_fee_total: 'Poplatek za doručení celkem',
            promo: 'Sleva: {{name}} ({{value, currency}} + {{percent}}% sleva)',
            promo_percent: 'Sleva: {{name}} ({{percent}}%)',
            promo_fixed: 'Sleva: {{name}}',
            promo_none: 'Sleva: {{name}}',
            cart: 'Vozík',
            tip: 'Tip na objednávku',
            total: 'Celkový',
        },
        status: {
            unconfirmed: 'Nepotvrzeno',
            awaiting_payment: 'Čeká na platbu',
            confirmed: 'Potvrzeno',
            ready: 'Připraveno',
            on_route: 'Na Route',
            complete: 'Kompletní',
            cancelled: 'Zrušeno',
            seated: 'Usazeno',
        },
        searching: {
            lalamove_search_placeholder: 'Vyhledejte objednávku podle ID doručení Lalamove',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'Není k dispozici',
                },
            },
            dish: {
                no_stock: 'Není skladem',
                not_available: 'Není k dispozici',
            },
        },
    },
    admin: {
        registration: {
            register_confirmation_code_subject: 'Potvrzovací kód e-mailu',
            register_confirmation_code_email: 'Váš potvrzovací kód e-mailu je {{confirmation_code}} (vyprší za 24 hodin)',
            register_confirmation_code_email_onbehalf: 'Váš potvrzovací kód e-mailu je {{confirmation_code}} (vyprší za 24 hodin). Toto je pro e-mailovou adresu, {{email}}.',
        },
    },
};
//# sourceMappingURL=cs.js.map